'use client'

import React from 'react'
import styles from './styles.module.scss'

interface SettingButtonProps {
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  onClick?: () => void
  children: React.ReactNode
  variant?: 'primary' | 'secondary'
  isValid?: boolean
  round?: boolean
  used?: string
}

const SettingButton: React.FC<SettingButtonProps> = ({
  type = 'button',
  disabled = false,
  onClick,
  children,
  variant = 'primary',
  isValid = true,
  round = true,
  used = '',
}) => {
  const getClassName = () => {
    let className = `${styles.buttonBase}`

    if (round) {
      className += ` ${styles.round}`
    }

    if (variant === 'primary' && isValid) {
      className += ` ${styles.submit}`
    } else if (variant === 'secondary') {
      className += ` ${styles.backButton}`
    }

    if (used) {
      className += ` ${styles[used]}`
    }

    return className
  }

  return (
    <button type={type} disabled={disabled} onClick={onClick} className={getClassName()}>
      {used === 'error' && <i className='icon-font-icon_login' />}
      {children}
    </button>
  )
}

export default SettingButton
